import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/layout')
  },
  {
    path: '/shop',
    name: 'shop',
    component: () => import('@/views/shop/shop.vue')
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('@/views/blog/blog.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/views/detail/detail.vue')
  },
  {
    path: '/wishlist',
    name: 'wishlist',
    component: () => import('@/views/wishlist/wishlist.vue')
  },
  {
    path: '/store',
    name: 'store',
    component: () => import('@/views/store/store.vue')
  },
  {
    path: '/shop-detail',
    name: 'shopDetail',
    component: () => import('@/views/shopDetail/shopDetail.vue')
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import('@/views/checkout/checkout.vue')
  },
  {
    path: '/our-store',
    name: 'ourStore',
    component: () => import('@/views/ourStore/ourStore.vue')
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/views/faq/faq.vue')
  },
  {
    path: '/about-us',
    name: 'aboutUs',
    component: () => import('@/views/about/about.vue')
  },
  {
    path: '/refund-policy',
    name: 'RefundPolicy',
    component: () => import('@/views/refund-policy')
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/privacy-policy')
  },
  {
    path:'/terms-of-service',
    name:'TermsOfService',
    component: () => import('@/views/terms-of-service')
  },
  {
    path:'/about-us-footer',
    name:'AboutUsFooter',
    component: () => import('@/views/about-us-footer')
  },
  {
    path:'/contact-us',
    name:'ContactUs',
    component: () => import('@/views/contact-us')
  },
  {
    path:'/questions',
    name:'questions',
    component: () => import('@/views/questions')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  // 核心配置：路由切换时的滚动行为
  scrollBehavior() {
    // 返回 { x: 0, y: 0 } 表示滚动到页面顶部
    return { x: 0, y: 0 }
  }
})

export default router
